<template>
  <div
    v-if="message && message !== '' && show"
    @click="click"
    :class="`cxco-c-notify cxco-c-notify--${type || ''}`"
    role="alert"
    aria-live="polite"
  >
    <Icon v-if="type === 'error'" :name="'error'" aria-hidden="true" />
    <Icon v-if="type === 'success'" :name="'success'" aria-hidden="true" />
    <Icon v-if="type === 'alert'" :name="'alert'" aria-hidden="true" />

    <span>{{ message }}</span>
  </div>
</template>
<script>
import Icon from "./icon";

export default {
  components: { Icon },
  props: {
    message: String,
    click: Function,
    show: Boolean,
    type: String,
  },
};
</script>
